// extracted by mini-css-extract-plugin
export default {"h2":"style_h2__3k6Sk"};